// extracted by mini-css-extract-plugin
export default {"SortedColumn":"ColumnSorter_SortedColumn__Qhwxv","SortingArrow":"ColumnSorter_SortingArrow__cqbw0","Active":"ColumnSorter_Active__5Vfmv"};